import React, { FunctionComponent } from "react"
import { MonitorIcon } from "../../assets/monitorIcon"
import "./index.css"

interface OnlyOnDesktopProps {
  color?: string
}

const OnlyOnDesktop: FunctionComponent<OnlyOnDesktopProps> = ({
  color = "yellow",
}) => {
  return (
    <div className="desktop-only-msg">
      <MonitorIcon color={color} />
      <p className={color}>Only on desktop, for now</p>
    </div>
  )
}

export default OnlyOnDesktop
